import { render, staticRenderFns } from "./settingsNav.vue?vue&type=template&id=1547bbc8"
import script from "./settingsNav.vue?vue&type=script&lang=js"
export * from "./settingsNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports